import React, { Component } from 'react';
import storage from 'store';
import * as clevertapCapital from 'clevertap/capital';
import { connect } from 'react-redux';
import { CAPITAL_INTRO_PAGE } from 'utils/capitalUtils';
import { setCapitalPage, pageRequestDashboard } from 'actions/capital';
import styles from './Rejected.css';

class Rejected extends Component {
  componentDidMount() {
    storage.set('hasClickApply', false);

    clevertapCapital.preApprovalRejection();
  }

  render() {
    const title = 'Sorry you don’t meet the minimum requirements';
    const description =
      'Sorry but you’re ineligible to apply for a loan at the moment. This could be due to low sales, high cost, low tenure with Moka, outlet location, etc. Please try again later.';
    return (
      <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding`}>
        <div className="full-height-no-data-display">
          <div className={`${styles['not-requirement-container']} box-spinner`}>
            <div className={`${styles['content-not-requirement']}`}>
              <img src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/not_meet_the_requirement.svg" />
              <div>
                <h3 className={styles.title}>{title}</h3>
              </div>
              <div
                className={`${styles.description} ${
                  styles['description-box']
                } col-md-9 col-lg-9`}
              >
                <p>{description}</p>
              </div>
              <a onClick={this._onClickClose} className={styles.close}>
                Close
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickClose = () => {
    const {
      dispatch,
      borrowerProfile: { firstLoan },
    } = this.props;
    if (firstLoan) {
      dispatch(setCapitalPage(CAPITAL_INTRO_PAGE));
    } else {
      dispatch(pageRequestDashboard());
    }
  };
}

Rejected.propTypes = {};

function mapStateToProps(state) {
  const { borrowerProfile } = state.capital;
  return {
    borrowerProfile,
  };
}

export default connect(mapStateToProps)(Rejected);
